export enum MirrorTrackingNamespace {
  LIST_JS = 'list_js',
  LIST_NO_JS = 'list_no_js',
}

export enum MirrorTrackingType {
  COMMON_TYPE = 'common',
  NO_JS_TYPE = 'nojs',
}
